import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class ProjectLocks extends BaseModel {
  constructor() {
    super(collection(db, 'project_locks'))
  }
}
